export function reportReducer(state = "",{
    type,
    payload
}){
    switch(type){
        case "GET_REPORTS":
            return payload;
        case "UPDATE_REPORT":
            return {
                ...state,
                [payload.id]: payload
            };
        case "POPUP_CLIENT_MESSAGES_LIST": // ??
            return state;
        default:
            return state;
    }
}